<template>
  <div style="padding: 20px 0; ">
    <!-- 搜索框 -->
    <div style="margin-bottom: 20px;background-color: #fff;padding: 20px;">
      <span>手机号：</span>
      <input
        v-model="searchKeyword"
        placeholder="请输入手机号搜索"
        class="input_number"
      />
      <el-button type="primary" @click="search">搜索</el-button>
    </div>

    <!-- 树形结构 -->
    <div class="tree_box">
      <org-tree
        :treeData="filteredTreeData"
        :props="defaultProps"
        default-expand-all
      >
        <!-- 自定义节点显示为多行 -->
        <template #node="{ node }">
          <div class="node_box">
            {{ node.name }}
          </div>
        </template>
      </org-tree>
    </div>

    <!-- 错误提示 -->
    <div v-if="!filteredTreeData || filteredTreeData.name === '未找到匹配项'" style="color: red; margin-top: 10px;">
      未找到相关数据
    </div>
  </div>
</template>

<script>
import OrgTree from 'vue-org-tree';
import { post } from '@/utils/request.js';

export default {
  name: 'OrgChart',
  components: { OrgTree },
  data() {
    return {
      defaultProps: {
        children: 'children',
        label: 'name'
      },
      originalTreeData: null,
      filteredTreeData: { name: '请先搜索手机号', children: [] },
      searchKeyword: '',
    };
  },
  methods: {
    // 搜索方法
    search() {
      const keyword = this.searchKeyword.trim();
      if (!keyword) {
        this.$message.info('请输入手机号');
        return;
      }

      if (!/^1[3456789]\d{9}$/.test(keyword)) {
        this.$message.warning('请输入正确的手机号码');
        return;
      }
      // 发起请求
      post(`/tianyilife/user/userTree`, {phone:keyword})
        .then(res => {
          if (res.success) {
            this.originalTreeData = this.formatNode(res.data);
            this.filteredTreeData = this.originalTreeData;
          } else {
            this.filteredTreeData = { name: '未找到匹配项', children: [] };
          }
        })
        .catch(err => {
          console.error('请求失败:', err);
          this.$message.error('请求失败，请重试');
          this.filteredTreeData = { name: '请求失败', children: [] };
        });
    },

    // // 高亮匹配节点
    // highlightNodes(node, keyword) {
    //   if (!node) return null;

    //   const matches = node.name && node.name.toLowerCase().includes(keyword.toLowerCase());

    //   if (matches) {
    //     node._highlighted = true;
    //     return { ...node, _highlighted: true };
    //   }

    //   if (node.children && node.children.length > 0) {
    //     const highlightedChildren = node.children
    //       .map(child => this.highlightNodes(child, keyword))
    //       .filter(child => child !== null);

    //     if (highlightedChildren.length > 0) {
    //       return { ...node, children: highlightedChildren, _highlighted: true };
    //     }
    //   }

    //   return node;
    // },
    // 格式化单个节点
    formatNode(node) {
      if (!node) return null;

      const hasChildren = node.childrenList && node.childrenList.length > 0;

      return {
        ...node,
        name: `手机号：${node.userMobile}\n账号：${node.userName}\n业绩：${node.sumoyj ? node.sumoyj+'元' : '--'}`,
        children: hasChildren ? node.childrenList.map(this.formatNode) : [],
        _isLeaf: !hasChildren,
        _highlighted: false
      };
    }
  }
};
</script>

<style scoped>
.tree_box{
   height: 600px; 
   border: 1px solid #eee;
}
::v-deep .orgTree{
   padding: 20px;
   background-color: #fff;
}

.input_number{
   width: 200px;
   height: 42px;
   border: 1px solid #464b4b;
   padding-left: 15px;
   margin-right: 15px;
  }
 

::v-deep .item-container {
  font-size: 16px !important;
  color: #181818 !important;
  white-space: pre-wrap !important;/** 强制换行**/
  text-align: left !important;
  line-height: 1.2 !important;
}

/* ::v-deep .item-container:hover{
   font-size: 18px !important;
   color: #181818 !important;
} */

/* 高亮节点样式 */
::v-deep .org-tree-node-label._highlighted {
  background-color: #ffeeba !important;
  font-weight: bold !important;
  border: 1px solid #ffc107 !important;
  color: #856404 !important;
  font-size: 16px !important;
}
</style>
